import * as React from 'react';

const NavBar = function () {
  return (
      <div className="cmp-main-navbar">
        <div className="img-container">
          <img className="img-fluid" alt="" src="https://static.retail.autofact.cl/img/logo-blanco.svg"/>
        </div>
      </div>
  )
};

export default NavBar;
